import React, { useState } from 'react';
import styled from 'styled-components';

import { primaryColor } from '../../constants/COLORS';

type SetAdvanceSearch = React.Dispatch<
  React.SetStateAction<{
    [key: string]: any;
  }>
>;
export interface AdvanceSearchObject {
  payload_key: string;
  Component: React.FunctionComponent<{
    value: any;
    setAdvanceSearch: SetAdvanceSearch;
  }>;
  defaultValue: any;
  payloadFormatter?: (payload: any, value: any) => any;
  searchQueryParser?: (value: string | string[]) => any;
}

type Props = {
  advanceSearches: AdvanceSearchObject[];
  setAdvanceSearch: SetAdvanceSearch;
  advanceSearchState: {
    [key: string]: any;
  };
};

const AdvanceSearch = (props: Props) => {
  const [expand, setExpand] = useState(false);

  return (
    <Wrapper>
      {expand && (
        <div className="advance-search-filters">
          {props.advanceSearches.map((obj, idx) => {
            return (
              <obj.Component
                key={`${obj.payload_key}-${idx}`}
                value={props.advanceSearchState[obj.payload_key]}
                setAdvanceSearch={props.setAdvanceSearch}
              />
            );
          })}
        </div>
      )}
      <p
        onClick={() => setExpand(exp => !exp)}
        className="toggle-text"
        style={{ marginTop: expand ? 10 : 0 }}
      >
        {expand ? 'Hide ' : ''}Advance Search
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  p.toggle-text {
    color: ${primaryColor};
    width: fit-content;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .advance-search-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > * {
      margin-bottom: 10px;
    }
  }
`;

export default AdvanceSearch;
